import { EN_STRING_ACTIVITY_OVERRIDES } from './entities/activity-strings';
import { EN_CAMPAIGN_STRINGS } from './entities/campaigns-strings';
import { EN_QUESTION_CODE_STRINGS } from './entities/question-code-strings';
import { EN_QUESTION_UNIT_STRINGS } from './entities/question-units-strings';
import { EN_QUESTIONNAIRE_STRINGS } from './entities/questionnaire-strings';
import { EN_MASONRY_QUESTIONNAIRE_STRINGS } from './entities/masonry-questionnaire-strings';
import { EN_REWARDS_CONFIGURATION_STRINGS } from './entities/rewards-configuration-strings';
import { EN_CONDITIONAL_ACTION_STRINGS } from './entities/conditional-action-strings';
import { EXAMPLE_ENTITY_STRINGS } from './entities/example-entity-strings';
import { EN_TEST_USER_STRINGS } from './entities/test-users';
import { EN_LPF_STRINGS } from './entities/lpf-strings';
import { EN_CAREGIVER_STRINGS } from './entities/caregiver-strings';
import { COMMON_ENTITY_STRINGS } from './entities/common-entity-strings';
import { EN_BENEFITS_STRINGS } from './entities/benefits-strings';
import { EN_MEDIA_STRINGS } from './entities/media-strings';
import { EN_CONTENT_METADATA_STRINGS } from './entities/content-metadata-strings';
import { EN_MASONRY_CONTENT_STRINGS } from './entities/masonry-content-strings';
import { EN_MEMBER_OUTREACH_RECOMMENDATIONS_STRINGS } from './entities/member-outreach-recommendations-strings';
import { EN_MEMBER_OUTREACH_QUESTIONNAIRES_STRINGS } from './entities/member-outreach-questionnaires-strings';
import { EN_APP_REVIEW_STRINGS } from './entities/app-review-strings';

export const EN_STRING_OVERRIDES = {
  DEVELOPMENT: 'Development',
  LIST_TABLE_EMPTY_CELL_VALUE: 'Not set',
  EMPTY_ENTITY_TITLE: 'No {entity} here (yet)',
  EMPTY_ENTITY_DESCRIPTION:
    'You can manage {entity} here and reference them across the {tenant} experience.',
  EMPTY_SELECTABLE_TABLE_PUBLISHED_ENTITY_DESCRIPTION:
    'Publish {entity} to reference them here.',
  EMPTY_SELECTABLE_TABLE_ENTITY_DESCRIPTION:
    'Create {entity} to reference them here.',
  ERROR_ENTITY_TITLE: 'Something went wrong loading {entity}.',
  ERROR_ENTITY_DESCRIPTION:
    'We are unable to access {entity} at this time, please try again later.',
  ADMIN: 'Admin',
  ADMIN_TOOLS: 'Admin Tools',
  MODULE_NOT_FOUND_ON_TENANT:
    'Could not find module "{moduleId}" on tenant {tenant}',
  JOURNEY: 'Journey',
  LEAGUE_CONFIGURATION: 'League Configuration',
  MASONRY: 'Masonry',
  OUTREACH: 'Outreach',
  UAT_UTILITIES: 'UAT Utilities',
  CREATE: 'Create',
  EXIT_ENTITY_DETAIL_TITLE: 'Discard changes to {entity}?',
  EXIT_ENTITY_DETAIL_DESCRIPTION:
    'Changes you have made since you last saved or published will not be persisted.',
  EXIT_ENTITY_DETAIL_PRIMARY_CTA: 'Discard and Close',
  CLOSE: 'Close',
  DONE: 'Done',
  PUBLISH: 'Publish',
  PROFILE: 'Profile',
  DEFAULT: 'Default',
  LOG_OUT: 'Log Out',
  HELP: 'Help',
  SORRY_WE_CANT_FIND_PAGE:
    'We’re sorry, we can’t find the page you’re looking for.',
  ENVIRONMENT_NOT_FOUND_ON_TENANT:
    'Could not find environment "{environmentKey}" on tenant {tenant}',
  TENANT_ACCESS_DENIED_HEADING:
    'You do not have access to this workspace. Please contact your administrator or try logging in with a different account.',
  DISCOVERY_TOKEN_ERROR_HEADING:
    'Something went wrong while signing you in. Please try logging out and signing in again.',
  NO_ACCESSIBLE_TENANTS_FOUND:
    'No accessible tenants found. Please contact your League administrator.',
  DATA_POINT_LOADING_ERROR: 'Data Point Loading Error',
  UNPUBLISH_MODAL_TITLE: 'Unpublish {entity} from {env}?',
  UNPUBLISH_MODAL_DESCRIPTION:
    'When removed, users will no longer be able to see this {entity} on the live environment. You can still make edits and/or promote in the future.',
  UNPUBLISH_PRIMARY_CTA: 'Unpublish from {env}',
  ENTITY_DETAIL_LOAD_ERROR_TITLE: 'Loading Error',
  ENTITY_DETAIL_LOAD_ERROR_DESCRIPTION:
    'An unexpected error occurred while loading this page',
  RETURN_HOME: 'Return Home',
  LOADING: 'Loading',
  AUDIT_LOG_AFFECTED_OBJECT: 'Affected Object',
  AUDIT_LOG_CHANGED_FROM: 'Changed From',
  AUDIT_LOG_CHANGED_TO: 'Changed To',
  AUDIT_LOG_NO_CHANGES: 'No changes to display',
  AUDIT_LOG_CHANGE_DETAILS: 'Change Details',
  AUDIT_LOG_CHANGE_DETAILS_FOR:
    'Changes from version {previousEntityVersion} to version {entityVersion}',
  AUDIT_LOG_CHANGES_TO_VERSION: 'Changes to version {entityVersion}',
  AUDIT_LOG_VERSION: 'Version',
  AUDIT_LOG_DATE: 'Date',
  AUDIT_LOG_USER: 'User',
  AUDIT_LOG_STATUS: 'Status',
  AUDIT_LOG_ACTION_TYPE: 'Action Type',
  AUDIT_LOG_NUMBER_OF_CHANGES: 'Number of Changes',
  AUDIT_LOG_EXPAND_VERSION_DATA: 'Expand version data difference',
  AUDIT_LOG_EXPAND_ROW_DATA: 'More Details',
  AUDIT_LOG_COLLAPSE_ROW_DATA: 'Less Details',
  EXPAND_SIDE_PANEL: 'Expand side panel',
  COLLAPSE_SIDE_PANEL: 'Collapse side panel',
  PUBLISHED: 'Published',
  PUBLISH_CHANGES: 'Publish Changes',
  PUBLISHING: 'Publishing',
  RE_PUBLISHING: 'Re-publishing',
  DRAFT: 'Draft',
  ARCHIVED: 'Archived',
  ARCHIVE: 'Archive',
  UN_ARCHIVE: 'Unarchive as Draft',
  UN_ARCHIVING: 'Unarchiving',
  UNSAVED_CHANGES: 'Unsaved changes',
  ALL_CHANGES_SAVED: 'All changes saved',
  ALL_CHANGES_PUBLISHED: 'All changes published',
  UNPUBLISHED_CHANGES: 'Unpublished changes',
  UNPUBLISH: 'Unpublish',
  DUPLICATE_AS_DRAFT: 'Duplicate as Draft...',
  EXIT_AND_DISCARD_CHANGES: 'Exit and Discard Changes',
  UNPUBLISH_BEFORE_YOU_ARCHIVE:
    'You must unpublish this {entity} before you can archive it.',
  SAVE_BEFORE_YOU_DUPLICATE:
    'You must save your changes before you can duplicate this {entity}.',
  SAVE_DRAFT: 'Save Draft',
  SAVE_CHANGES: 'Save Changes',
  SAVING: 'Saving',
  NAME: 'Name',
  ID: 'ID',
  ERROR_ID: 'Error ID',
  LAST_UPDATED: 'Last Updated',
  STATUS: 'Status',
  SELECT_AT_LEAST_ONE_STATUS: 'Select at least one status',
  COPY: 'Copy {title}',
  COPY_ENTITY_ID: 'Copy entity ID',
  COPY_URL: 'Copy URL',
  FIRST: 'First',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  LAST: 'Last',
  DELETE_ITEM_ARRAY_TOOLTIP: 'Delete {item} from list.',
  DUPLICATE_ITEM_TOOLTIP: 'Duplicate {item}.',
  MOVE_ITEM_UP_TOOLTIP: 'Move {item} up.',
  MOVE_ITEM_DOWN_TOOLTIP: 'Move {item} down.',
  MOVE_TO_POSITION_TOOLTIP: 'Move {item} to a specific position.',
  MOVE_TO_POSITION: 'Move to Position',
  DRAG_TO_REORDER_TOOLTIP: 'Drag or press Space to reorder {item}.',
  DRAG_TO_REORDER_SCREEN_READER:
    'Press space to pick up {item}. Use your arrow keys to move it, and press space to drop it.',
  ADD_ITEM: 'Add {item}',
  DELETE: 'Delete',
  DUPLICATE: 'Duplicate',
  UP: 'Up',
  DOWN: 'Down',
  CANCEL: 'Cancel',
  RETRY: 'Retry',
  DELETE_CONFIRMATION_MODAL_TITLE: 'Are you sure?',
  DELETE_ARRAY_ITEM_MODAL_DESCRIPTION:
    'Deleting <strong>{item}</strong> will remove all configurations that you have made for that item, and any of its children.',
  LIST_ITEM: 'List item',
  ADD_BY_ID: 'Add by ID',
  CHOOSE_FROM_LIST: 'Choose from a list',
  CHOOSE_ENTITY_FROM_LIST: 'Choose {entityName}',
  CHANGE_SELECTION: 'Change Selection',
  ENTITY_NAME: 'Entity Name',
  ENTITY_NAME_ARTICLE:
    '{startsWith, select, consonant {a} vowel {an} other {a}}',
  CHOOSE_ENTITY: 'Choose {entityName}',
  ENTITY_ID: 'Entity ID',
  OBJECT_CARD_LINK_OPENS_IN_OWN_PAGE: 'link, opens in its own page',
  MISSING_LABEL_ANNOTATION: 'MISSING: x-entity-label annotation at {path}',
  ADDRESS_OR_USER: 'Address or User',
  USER_KEY: 'User',
  ADDRESS_KEY: 'Address',
  INTERNAL_NAME: 'Internal Name',
  LIST: 'List',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  SIMPLE: 'Simple',
  STANDARD: 'Standard',
  DETAILED: 'Detailed',
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
  SUBTLE: 'Subtle',
  TITLE: 'Title',
  SINGLE: 'Single',
  MULTI: 'Multi',
  REQUIRED: 'Required',
  MANUAL: 'Manual',
  SLIDER: 'Slider',
  COUNTER: 'Counter',
  BADGE: 'Badge',
  EVENT: 'Event',
  ALT_TEXT: 'Alt Text',
  BACKGROUND_COLOR: 'Background Color',
  BORDER_RADIUS: 'Border Radius',
  HORIZONTAL_ALIGNMENT: 'Horizontal Alignment',
  START: 'Start',
  CENTER: 'Center',
  END: 'End',
  UNIT: 'Unit',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  VALUE: 'Value',
  INFO: 'Info',
  STRING: 'String',
  INTEGER: 'Integer',
  DECIMAL: 'Decimal',
  CODING: 'Coding',
  DATE: 'Date',
  TIME: 'Time',
  ANSWER: 'Answer',
  CODE: 'Code',
  CODE_WITH_VALUE: 'Code: {code}',
  METRIC: 'Metric',
  OBSERVATION: 'Observation',
  CORE: 'Core',
  LPF: 'LPF',
  GOAL: 'Goal',
  PILL: 'Pill',
  LINE: 'Line',
  BOX: 'Box',
  CHALLENGE: 'Challenge',
  NEW: 'New',
  DUPLICATE_OF: 'Duplicate of',
  /** rich text toolbar */
  NORMAL_LABEL: 'Normal',
  HEADING_1_LABEL: 'Heading 1',
  HEADING_2_LABEL: 'Heading 2',
  HEADING_3_LABEL: 'Heading 3',
  HEADING_4_LABEL: 'Heading 4',
  HEADING_5_LABEL: 'Heading 5',
  HEADING_6_LABEL: 'Heading 6',
  NUMBER_LIST_LABEL: 'Number list',
  BULLET_LIST_LABEL: 'Bullet list',
  QUOTE_LABEL: 'Quote',
  UNDO_LABEL: 'Undo',
  REDO_LABEL: 'Redo',
  BOLD_LABEL: 'Bold',
  INSERT_LINK_LABEL: 'Insert link',
  ITALIC_LABEL: 'Italic',
  STYLES_LIST: 'Styles list. {selectedBlockElement} text selected.',
  UNTITLED: 'Untitled',
  DEFAULT_ENUM_PLACEHOLDER: 'Select an option',
  ADD_IMAGE: 'Add Image',
  ADD_PDF: 'Add PDF',
  CONTENTFUL_ID: 'Contentful ID',
  ADD_IMAGE_BY_CONTENTFUL_ID: 'Add image by Contentful ID',
  IMAGE_URL: 'Image URL',
  USE_IMAGE_URL: 'Use Image URL',
  IMAGE_URL_HINT:
    'Please use a fully qualified URL. For example, (https://....)',
  INVALID_URL: 'Not a valid URL. Please check your input and try again.',
  CHOOSE_IMAGE_FROM_COMPUTER: 'Choose image from computer',
  CLEAR_SELECTED_IMAGE: 'Clear selected image',
  UNABLE_TO_FIND_IMAGE:
    'Unable to find this image. Please check the Contentful gallery or fix any entry errors.',
  UNABLE_TO_FIND_ENTITY: 'No {entityName} was found matching this ID.',
  COULD_NOT_LOAD_IMAGE: 'Could not load image from Contentful',
  SELECT_AN_IMAGE: 'Select an image',
  SELECT_AN_EXISTING_IMAGE: 'Select an existing image',
  MORE_ACTIONS: 'More actions',
  NO_ARRAY_ITEMS_YET: 'No {item} yet.',
  RULE_TEMPLATE: 'Rule Template',
  CHOOSE_A_RULE_TEMPLATE: 'Choose a rule template',
  JSON_LOGIC: 'JSONLogic',
  EQUALS: 'Equals',
  BEFORE: 'Is before',
  AFTER: 'Is after',
  BEFORE_OR_EQUALS: 'Is before or equals',
  AFTER_OR_EQUALS: 'Is after or equals',
  RULE_VIEW_OPTIONS_ARIA_LABEL: 'Rule view options',
  RULE: 'Rule',
  APPLY: 'Apply',
  UPLOAD_IMAGE: 'Upload Image',
  CHANGE_IMAGE: 'Change Image',
  CHANGE_FILE: 'Change File',
  FILE_TYPE_NOT_SUPPORTED:
    'File type {fileType} is not supported. The following file types are supported: {allowedFileTypes}',
  FILE_TOO_LARGE_ERROR:
    'Maximum file size is {maxSize}. This file is {currentSize}.',
  NO_FILE_INCLUDED_ERROR: 'Please add a file before attempting to upload',
  NO_TITLE_INCLUDED_ERROR: 'Please add a title before attempting to upload',
  ERROR_LOADING_ENTITY_REFERENCE:
    '{hasValue, select, true {Unable to find a reference for: {value}} other {There was a problem loading reference.}}',
  MISSING_RELATIONSHIP:
    'Error: no relationship found for ID {entityId}. Try removing and adding the entity or contact support if the problem persists.',
  CLEAR_ENTITY_REFERENCE_SELECTION: 'Clear Selection',
  WIDGETS: '{count, plural, one {Widget} other {Widgets}}',
  CONTAINERS: '{count, plural, one {Container} other {Containers}}',
  ASSETS: '{count, plural, one {Asset} other {Assets}}',
  EMPTY_RULES_TEMPLATE: 'None',
  DOMAIN_ENTITY_CONFIGURATION_ERROR:
    '{count, plural, one {{entityConfigName} Error: There is an error in your configuration.} other {{entityConfigName} Error: There are # errors in your configuration}}',
  VALIDATION_CONFIGURATION_ERROR:
    '{count, plural, one {Validation Error: There is an error in your configuration.} other {Validation Error: There are # errors in your configuration}}',
  SERVER_ERROR: 'Server Error',
  SELECTED: 'Selected',
  CURRENT_ENVIRONMENT_PRECEDING_LABEL: 'Current Environment:',
  ENVIRONMENT_SELECT: 'Environment select: {environmentName} {status} selected',
  EXIT_ENVIRONMENT_MODAL_CONFIRM_CTA: 'Discard and Switch',
  EXIT_ENVIRONMENT_MODAL_DESCRIPTION:
    'Changes you have made since you last saved or published will not be persisted if you switch environments.',
  CHOOSE_ENVIRONMENT: 'Choose Environment',
  PUBLISHING_DANGEROUSLY_STATUS_BANNER:
    'You are editing {environmentName} directly. Any change you submit will be immediately published to the live app.',
  READONLY_CONFIG_STATUS_BANNER:
    'This is a read only {entity}. You can view the configuration but cannot make any changes.',
  SAVING_ACTION: 'Saving {entity}...',
  PUBLISHING_ACTION: 'Publishing {entity}...',
  REPUBLISHING_ACTION: 'Republishing {entity}...',
  UNPUBLISHING_ACTION: 'Unpublishing {entity}...',
  ARCHIVING_ACTION: 'Archiving {entity}...',
  UNARCHIVING_ACTION: 'Unarchiving {entity}...',
  CLONE_ACTION: 'Duplicating {entity}...',
  COPYING_TO_ENVIRONMENT_ACTION: 'Copying {entity} to {environment}...',
  DEEP_CLONING_ACTION: 'Cloning {entity}...',
  DEEP_CLONE_MODAL_FETCH_ERROR_MESSAGE:
    'Error fetching deep clone data: {serverErrorMessage}',
  SYNCING_ASSETS_WITH_ENVIRONMENT_ACTION:
    'Syncing images with {environment}...',
  COPY_TO_ENVIRONMENT_SUCCESS: 'Copied to {environment} successfully',
  BULK_PROMOTE_ALL_ERROR_TITLE:
    'Error copying {entityName} to {environmentName}',
  BULK_OPERATION_ERROR_MESSAGE:
    'Please try again or contact support if the issue persists.',
  BULK_PROMOTE_ALL_ERROR_MESSAGE_FALLBACK:
    'An error occurred while copying {entityName} to {environmentName}. Please try again and contact support if the problem persists.',
  COPY_TO_ENVIRONMENT_ACTION: 'Copy to {environment}',
  COPY_TO_ENVIRONMENT_DANGEROUSLY_MODAL_TITLE: 'Copy to {environment}',
  COPY_TO_ENVIRONMENT_DANGEROUSLY_MODAL_DESCRIPTION:
    'This {entity} does not exist in {environment} yet. Copying creates it in {environment}, along with every entity it references. This cannot be undone here.',
  COPY_TO_ENVIRONMENT_DANGEROUSLY_MODAL_PRIMARY_CTA: 'Copy to {environment}',
  COPY_TO_ENVIRONMENT_DANGEROUSLY_MODAL_CHECKBOX:
    'I acknowledge that this {entity}, and every entity it references, will be created in {environment}.',
  COPY_TO_ENVIRONMENT_UNSUPPORTED_ENTITY_DATA_TYPE:
    'Unsupported entity data type, please try again and contact support if the problem persists.',
  PUBLISH_DANGEROUSLY_MODAL_TITLE: 'Publish to {environment}',
  PUBLISH_DANGEROUSLY_MODAL_DESCRIPTION:
    'Publishing to {environment} will make this {entity} visible to your customers.',
  PUBLISH_DANGEROUSLY_MODAL_PRIMARY_CTA: 'Publish to {environment}',
  PUBLISH_DANGEROUSLY_MODAL_CHECKBOX:
    'I acknowledge that this {entity} is being published in {environment}.',
  DEEP_PUBLISH_MODAL_TITLE: 'Publish with referenced entities',
  DEEP_PUBLISH_MODAL_DESCRIPTION:
    'Review the entities below that will be published together. Draft entities will be published, and already-published entities will be skipped.',
  DEEP_PUBLISH_MODAL_FETCHING_TEXT: 'Discovering referenced entities\u2026',
  DEEP_PUBLISH_CHILD_ENTITIES_COUNT:
    '{count, plural, one {# referenced entity} other {# referenced entities}}',
  DEEP_PUBLISH_DUPLICATE_INDICATOR: '(already listed above)',
  DEEP_PUBLISH_CONFIRM_BUTTON:
    '{count, plural, one {Publish # entity} other {Publish # entities}}',
  DEEP_PUBLISH_ARCHIVED_ENTITY_FAILURE:
    'Publish not attempted because this entity is archived.',
  DEEP_PUBLISH_DISCOVERY_FAILURE_ERROR:
    'Some entities were not able to be loaded. Please resolve the issues with them and try again.',
  DEEP_PUBLISH_DEPENDENCY_FAILURE_SKIP:
    'Publish not attempted since a dependent entity failed to publish',
  DEEP_PUBLISH_DANGEROUSLY_CHECKBOX_WARNING:
    'Publishing to {environment} will make all entities above be visible to customers.',
  DEEP_PUBLISH_DANGEROUSLY_CHECKBOX_ACKNOWLEDGE:
    'I acknowledge that I want to proceed with this action.',
  BULK_PUBLISH_SELECTED_ENTITIES: 'Publish selected {entityName}',
  BULK_DEEP_PUBLISH_MODAL_TITLE: 'Publish selected entities with dependencies',
  BULK_DEEP_PUBLISH_MODAL_DESCRIPTION:
    'The following entities and their dependencies will be published.',
  BULK_DEEP_PUBLISH_FETCHING_TEXT:
    'Finding all entities needed to publish\u2026',
  BULK_DEEP_PUBLISH_FETCHING_COUNT:
    'Found {count, plural, one {# entity} other {# entities}} so far\u2026',
  BULK_DEEP_PUBLISH_CONFIRM_BUTTON:
    '{count, plural, one {Publish # entity} other {Publish # entities}}',
  BULK_DEEP_PUBLISH_ALREADY_INCLUDED: 'Already included above',
  BULK_PUBLISH_REQUIRES_DRAFT:
    'All selected entities must be in Draft status to publish',
  BULK_ARCHIVE_REQUIRES_DRAFT:
    'All selected entities must be in Draft status to archive',
  BULK_DELETE_REQUIRES_ARCHIVED:
    'All selected entities must be in Archived status to delete',
  COPY_TO_ENVIRONMENT_UNSAVED_CHANGES:
    'You must save your changes before you can copy this {entity}.',
  ENVIRONMENT_LABEL: 'Environment:',
  API_URL_LABEL: 'API URL:',
  AUDIENCE_LABEL: 'Audience:',
  ENVIRONMENT_TYPE_LABEL: 'Environment Type:',
  MULTI_ENVIRONMENT_ENABLED_LABEL: 'Multi-Environment Authoring Enabled:',
  ENVIRONMENT_INFO: 'Environment Info',
  VIEW_ALL_DATA: 'View all data',
  ENTITY_DATA_TABLE_CAPTION: 'Data for {entityName}',
  NO_DATA: 'No data',
  PATH: 'Path',
  DATA: 'Value',
  NO_RULE_PARAMETERS_NEEDED: 'No additional parameters needed',
  MINIMUM_VALUE: 'Minimum Value',
  MAXIMUM_VALUE: 'Maximum Value',
  PATH_TO_OBSERVATION_VALUE: 'Path to Observation Value',
  AGE: 'Age',
  CONDITION: 'Condition',
  DATA_POINT: 'Data Point',
  ALL_STRINGS_IN_LIST: 'All Strings in the List',
  STRING_LIST_DATA_POINT: 'String List Data Point',
  STRING_LIST: 'String List',
  JOINED_BEFORE_DAYS: 'Joined Before Days',
  CUTOFF_DATE: 'Cutoff Date',
  VALUE_ONE: 'Value One',
  VALUE_TWO: 'Value Two',
  QUESTION_LINK_ID: 'Question Link ID',
  ANSWER_CODES: 'Answer Codes',
  CLIENT_IDS: 'Client IDs',
  COHORT: 'Cohort',
  CLIENT_NUMBER: 'Client Number',
  SEX: 'Sex',
  CLIENT_GROUP_IDS: 'Client Group IDs',
  DATA_FOR_ENVIRONMENT: '{environment} Data',
  DOWNLOAD_AS_CSV: 'Download CSV',
  ENTITY_SINGLE_ENVIRONMENT_STATUS_BANNER:
    'This entity is only configurable on the {environment} environment.',
  DATA_POINT_MODAL_HEADING: 'Select Category',
  DATA_POINT_MODAL_INSTRUCTIONS: 'Choose a category to find a data point:',
  DATA_POINTS_ONLY_MODAL_HEADING: 'Select Data Point',
  SELECT_DATA_POINT: 'Select Data Point',
  BROWSE: 'Browse',
  VIEW_ATTACHMENTS: 'View Attachments',
  DEEP_CLONE_OPTIONAL_ENTITY_ITEM_RENAME: 'New name for {originalName}',
  DEEP_CLONE_ENTITY_CLONE_ITEM_CHILD_ENTITIES: 'Child entities ({count})',
  UPLOAD_ATTACHMENT_FROM_COMPUTER: 'Upload attachment from computer',
  ADD_ATTACHMENT_BY_CONTENTFUL_ID: 'Add attachment by Contentful ID',
  COULD_NOT_LOAD_ATTACHMENT: 'Could not load attachment from Contentful',
  UNABLE_TO_FIND_ATTACHMENT:
    'Unable to find this attachment. Please check Contentful or fix any entry errors.',
  ADD_ATTACHMENT: 'Add Attachment',
  UPLOAD_ATTACHMENT: 'Upload Attachment',
  FILE: 'File',
  COPY_FILE_PATH: 'Copy file path',
  DEEP_CLONE: 'Deep Clone',
  DEEP_CLONE_MODAL_TITLE: 'Assign names to duplicates',
  DEEP_CLONE_MODAL_DESCRIPTION:
    'The following entities will be duplicated. If you want to assign their names before duplication, you can do so below.',
  DEEP_CLONE_MODAL_PROCEED_BUTTON: 'Proceed with duplication',
  DEEP_CLONE_MODAL_FETCHING_TEXT: 'Preparing deep clone data&hellip;',
  DEEP_CLONE_MODAL_FETCH_NO_MESSAGE_PROVIDED: 'No error provided',
  DUPLICATE_THIS_AND_ALL_CHILDREN: 'Duplicate this and all children?',
  DUPLICATE_DISCLAIMER_MESSAGE:
    'This {entity} is linked to other entities. Would you like to also duplicate everything this {entity} points to? The new {entity} will point to those duplicated entities.',
  DUPLICATE_SECONDARY_ACTION_TEXT: 'Only duplicate this {entity}',
  DUPLICATE_PRIMARY_ACTION_TEXT: 'Duplicate all children as well',
  THIS_ENTITY: 'This {entity}',
  ATTACHMENT: 'Attachment',
  ATTACHMENTS: 'Attachments',
  ATTACHMENTS_MODAL_DESCRIPTION:
    'These attachments are associated to this entity. You can copy and paste the URLs below within other fields or links within rich-text. Note: We do not currently support deleting assets from the storage endpoint. If the asset is removed from this list, it will still exist in the system and can be referenced in the future.',
  CUSTOM_OPERATION_STEP_FAILED: 'Operation failed at "{stepName}":',
  OR_AT_LEAST_ONE_MUST_MATCH_RULE_COMBINATION:
    '(OR) At least one must match...',
  AND_ALL_MUST_MATCH_RULE_COMBINATION: '(AND) All must match...',
  NOR_MUST_NOT_MATCH_ANY_RULE_COMBINATION:
    '(NOR) Must not match any of the below...',
  SINGLE_RULE_CONDITION: 'Single rule condition...',
  COMBINE_RULES_WITH: 'Combine rules with...',
  NONE_RULES_TEMPLATE: 'None',
  ENTITY_SEARCH: 'Search all {entityName}',
  FILTER: 'Filter',
  FILTER_BY: 'Filter by',
  ADD_FILTER: 'Add Filter',
  CLEAR_ALL_FILTERS: 'Clear all filters',
  FILTER_ALREADY_SELECTED:
    'Filter already selected. Please edit the preexisting filter.',
  INCOMPLETE_FILTER: 'This filter is incomplete. Please set a value.',
  FILTER_BETWEEN_CONNECTOR: 'and',
  OR_CONNECTOR: 'or',
  ADD_OR_VALUE: '+ OR',
  REMOVE_OR_VALUE: 'Remove value',
  FILTER_SELECT_PLACEHOLDER: 'Select...',
  FILTER_PRIMARY_VALUE_PLACEHOLDER: 'type a value...',
  FILTER_ADDITIONAL_VALUE_PLACEHOLDER: 'value',
  FILTER_VALUE_ARIA_LABEL: 'Value for {field} filter',
  FILTER_SECOND_VALUE_ARIA_LABEL: 'Second value for {field} filter',
  FILTER_ADDITIONAL_VALUE_ARIA_LABEL:
    'Additional value {valuePosition} for {field} filter',
  CHANGE_FILTER_OPERATOR_ARIA_LABEL: 'Change operator for {field} filter',
  REMOVE_FILTER_ARIA_LABEL: 'Remove {field} filter',
  BOOLEAN_TRUE: 'True',
  BOOLEAN_FALSE: 'False',
  SEARCH: 'Search',
  RECENT_SEARCHES: 'Recent searches',
  NO_VALID_DATA_POINTS:
    'The filters configured by the League development team has resulted in no valid data points. Contact your representative at League to resolve this issue',
  NO_RESULTS_FOUND: 'No results found.',
  NO_RESULTS_FOUND_DESCRIPTION: 'You can search by name or ID.',
  NO_FILTER_RESULTS_FOUND: 'No filter results found.',
  NO_FILTER_RESULTS_FOUND_DESCRIPTION: 'Try adjusting your filters.',
  EDIT_ENTITY_NAME: 'Edit entity name',
  ERROR_IN_CHILD: 'Error in {childName}',
  ERROR_WRAPPER_MESSAGE:
    'Please contact support with this error message and a screenshot of the context.',
  DUPLICATE_CHILD_CLONE_NAME_HINT:
    'This entity is a duplicate child referenced multiple times. The name can only be edited a single time.',
  SET_ENTITY_JSON: 'Set Entity JSON',
  EDIT_ENTITY_JSON: 'Edit Entity JSON',
  ENTITY_JSON_INPUT_LABEL: 'Entity JSON',
  EDIT_JSON_WARNING_TEXT:
    'Editing the JSON directly can create broken data, save with caution.',
  VIEW_DEFAULT_LOCALE: 'View Default Locale',
  EMPTY_DEFAULT_LOCALE_DATA: 'No default locale data.',
  LOCALE_LABEL: 'Locale:',
  LOCALE_SELECT: 'Language select: {localeName} selected',
  CHOOSE_LOCALE: 'Choose Language',
  BROWSE_DATA_POINTS: 'Browse Data Points',
  COPY_DATA_POINT_ID: 'Copy Data Point ID for {label}',
  AI_ASSIST: 'AI Assist',
  AI_PROMPT_INPUT_LABEL: 'AI prompt',
  AI_ASSIST_PROMPT_INPUT_LABEL: 'AI assist prompt',
  AI_PROMPT_INPUT_PLACEHOLDER:
    'Describe the eligibility rule in plain language...',
  AI_ASSIST_GENERATE: 'Generate',
  AI_ASSIST_GENERATING: 'Generating...',
  GENERATE_JSON_LOGIC: 'Generate JSON logic',
  CLEAR_PROMPT: 'Clear prompt',
  AI_ASSIST_GENERATION_UNAVAILABLE:
    'AI generation is not configured for this field yet.',
  AI_GENERATION_ERROR:
    'Unable to generate JSON logic from this prompt. Please try again.',
  AI_GENERATION_UNAVAILABLE:
    'JSON logic generation is not configured for this field yet.',
  AI_ASSUMPTIONS_LABEL: 'Assumptions:',
  AI_AGENT_RESPONSE_LABEL: 'Agent Response:',
  LOCALE: 'Locale',
  MOVE_ITEM: 'Move Item',
  MOVE_ITEMS: 'Move Items',
  MOVE_ITEMS_DESCRIPTION: 'Move {count} item(s)',
  MOVE_ARRAY_ITEMS_DESCRIPTION:
    'Moving item(s) will add them to the top of the new list. You will need to reposition it after moving.',
  MOVE_TO_LABEL: 'Move to...',
  MOVE_FROM_LABEL: 'Move from...',
  MOVE_TO_POSITION_MODAL_TITLE: 'Move to Position',
  MOVE_TO_POSITION_MODAL_DESCRIPTION:
    'Move {item} to a specific position in the array.',
  TARGET_POSITION_LABEL: 'Target Position',
  TARGET_POSITION_PLACEHOLDER: 'Enter position (1-{max})',
  CURRENT_POSITION_INFO:
    '{item} is currently at position {currentPosition} of {totalItems} items.',
  INVALID_POSITION_ERROR: 'Please enter a valid number.',
  POSITION_OUT_OF_RANGE_ERROR: 'Position must be between 1 and {max}.',
  SAME_POSITION_ERROR: 'Item is already at this position.',
  MOVE: 'Move',
  NO_APPLICABLE_LOCATIONS:
    'No applicable locations exist to move this content.',
  CANCEL_MOVE: 'Cancel Move',
  SELECT_DESTINATION: 'Select Destination',
  SELECTOR: 'Selector',
  SUCCESS: 'Success',
  SKIPPED: 'Skipped',
  COMPLETED: 'Completed',
  MOVING_ITEMS_SUCCESS: 'Moving {items} was completed successfully.',
  MOVING_ITEMS_ERROR: 'Moving {items} failed. Please try again.',
  AUDIT_LOG: 'Audit Log',
  NO_AUDIT_LOG_ERROR:
    "We're having trouble loading content for this entity. Please try again later. If the problem persists, contact your League representative.",
  NO_AUDIT_LOG_EMPTY: 'No content was found for this entity.',
  DOMAIN_ENTITY_TYPE: 'Entity Type',
  DOMAIN_ENTITY_IDS: 'Entity IDs',
  ENTITY_BACKFILL: 'Entity Backfill',
  ACTIVITY_TRANSLATION: 'Activity Translation',
  TEMPLATE_INTERPRETER: 'Template Interpreter',
  EXAMPLE_COMPONENT_PAGE: 'Example Page',
  EXAMPLE_COMPONENT_PAGE_HEADING: 'Example Component Page',
  SETTINGS: 'Settings',
  REGENERATE_ID_TOOLTIP: 'Generate a new random ID',
  REGENERATE_ID: 'Regenerate ID',
  UNLOCK_ID_GENERATION_TOOLTIP: 'Unlock to enable generating a new ID',
  LOCK_ID_GENERATION_TOOLTIP: 'Lock ID generation to prevent changes',
  LOCK_ID_GENERATION: 'Lock ID Generation',
  UNLOCK_ID_GENERATION: 'Unlock ID Generation',
  NO_CHANGES_DETECTED: 'No changes detected',
  VIEW_GRAPH: 'View Graph',
  FLOW_GRAPH: 'Flow Graph',
  ACTION: 'Action',
  DECISION: 'Decision',
  BACKFILL_SYNC: 'Backfill Sync',
  BACKFILL_SYNC_DESCRIPTION:
    'Please fill in the information below to make sure contentful and CACT information for the change entities are consistent.',
  DOMAIN_ENTITY_IDS_HINT: 'Please enter a comma-separated list of ID values.',
  BACKFILL_ALL: 'Backfill All',
  BACKFILL_ALL_HINT:
    'Backfill every entity of the selected type. Auto-paginates through all entities; ignores any IDs entered below. Use when onboarding a new entity to CACT-BE or recovering from drift.',
  OVERWRITE: 'Overwrite Existing Entities',
  OVERWRITE_HINT:
    'When checked, entities that already exist in CACT are re-synced and their mirror is refreshed. Uncheck to skip existing entities and insert only new ones (insert-only). Applies to both specific Domain Entity IDs and Backfill All.',
  SUBMITTING: 'Submitting',
  BACKFILL_COMPLETED_SUCCESSFULLY: 'Backfill completed successfully',
  MEMBER_OUTREACH_TRIGGER: 'Trigger Outreach',
  MEMBER_OUTREACH_TRIGGER_DESCRIPTION:
    'Create a member outreach identity and code, and optionally send an SMS invitation to the member.',
  MEMBER_OUTREACH_QUESTIONNAIRE: 'Outreach Questionnaire',
  MEMBER_OUTREACH_QUESTIONNAIRE_HINT:
    'Select the published outreach questionnaire (landing page and questionnaire bundle) the guest sees when they open their outreach link.',
  MEMBER_OUTREACH_SEND_INVITATION: 'Send SMS Invitation',
  MEMBER_OUTREACH_SEND_INVITATION_HINT:
    'When enabled, the member receives an SMS invitation immediately after the outreach code is created.',
  MEMBER_OUTREACH_MEMBER_IDENTIFYING_ID: 'Member Identifying ID',
  MEMBER_OUTREACH_MEMBER_IDENTIFYING_ID_HINT:
    'External member identifier from the source system.',
  MEMBER_OUTREACH_FIRST_NAME: 'First Name',
  MEMBER_OUTREACH_LAST_NAME: 'Last Name',
  MEMBER_OUTREACH_DOB: 'Date of Birth',
  MEMBER_OUTREACH_DOB_HINT: 'Format: YYYY-MM-DD.',
  MEMBER_OUTREACH_PHONE_NUMBER: 'Phone Number',
  MEMBER_OUTREACH_PHONE_NUMBER_HINT: 'E.164 format, e.g. +15551234567.',
  SEND_INVITATION: 'Send Invitation',
  MEMBER_OUTREACH_INVITATION_SENT: 'Member outreach triggered successfully.',
  IMAGES: '{count, plural, one {Image} other {Images}}',
  PDFS: 'PDFs',
  PDF: 'PDF',
  IMAGE_PREVIEW: 'Image Preview',
  DESCRIPTION: 'Description',
  URL: 'URL',
  LINK_INVALID_URL: 'Enter a valid URL.',
  LINK_BLOCKED_PROTOCOL: 'This protocol is not allowed ({protocol}).',
  VALIDATE: 'Validate',
  VALIDATING_ACTION: 'Validating {entity}...',
  VALIDATION_PASSED: 'Validation returned no warnings or errors.',
  UPLOAD_FILE_ERROR:
    'There was a problem uploading your file. Please try again',
  THERE_ARE_ERRORS_IN_THIS: 'There are errors in this {item}',
  WARNING: 'Warning',
  CREATE_A_NEW_ENTITY: 'Create a new {entityName}',
  SYNC_TO_ENVIRONMENT_ACTION: 'Run Environment Sync...',
  SYNC_TO_ENVIRONMENT_ACTION_NAMED: 'Sync to {environment}...',
  ENVIRONMENT_STATUS_PENDING: 'Checking {environment}...',
  SYNC_ENVIRONMENT_UNSAVED_CHANGES:
    'You must save your changes before you can sync this {entity}.',
  DIFFERENCES_FOUND:
    '{count, plural, one {# difference found between environments} other {# differences found between environments}}',
  NO_DIFFERENCES_FOUND: 'No data difference between environments.',
  SHOW_ONLY_DATA_DIFFERENCES: 'Only show differences',
  ENVIRONMENT_SYNC_MODAL_TITLE: 'Compare environment data',
  SYNC_ENTITY: 'Sync {entityName}',
  SYNC_ENVIRONMENT_STATUS_MISMATCH:
    '{entity} status mismatch between environments',
  ENTITY_DATA_SYNC_TABLE_CAPTION:
    'Sync {entityName}: Replace {targetEnvironment} data with {sourceEnvironment} data.',
  GROUP_ERRORS:
    '{count, plural, one {{label} has {count} error} other {{label} has {count} errors}}',
  SYNC_ENVIRONMENT_DRAFT_TO_PUBLISH_NOT_ALLOWED:
    'You cannot sync a draft {entity} into a published {entity}.',
  SYNC_ENVIRONMENT_NOT_ALLOWED_STATUS:
    'This {entity} status is not supported for syncing.',
  SYNC_ENVIRONMENT_NOT_ALLOWED_REPUBLISH:
    'You cannot sync this {entity} as republishing is not allowed.',
  SYNC_ENVIRONMENT_NOT_ALLOWED_READ_ONLY:
    'You cannot sync this {entity} because it is read-only in {targetEnvironment}.',
  ENVIRONMENT_SYNCED_SUCCESSFULLY: 'Environment synced successfully',
  SYNC_DIRECTION_SOURCE_LABEL: 'Source (keeping)',
  SYNC_DIRECTION_TARGET_LABEL: 'Target (overwriting)',
  SYNC_OVERWRITE_WARNING:
    '{count, plural, one {This will permanently overwrite # field in {targetEnvironment}. This cannot be undone.} other {This will permanently overwrite # fields in {targetEnvironment}. This cannot be undone.}}',
  SYNC_TO_TARGET: 'Sync to {targetEnvironment}',
  SYNC_SOURCE_COLUMN_LABEL: '{environmentName} (source)',
  SYNC_TARGET_COLUMN_LABEL: '{environmentName} (will be overwritten)',
  OLD_VALUE_TO_BE_REPLACED: 'Old value to be replaced {value}.',
  NEW_VALUE: 'New value: {value}.',
  TABLE_CAPTION_DIFFERENCES_FOUND:
    '{count, plural, one {Data differences between environments, # difference found} other {Data differences between environments, # differences found}}.',
  TABLE_CAPTION_NO_DIFFERENCES_FOUND:
    'Data differences between environments, no differences found.',
  NO_SERVICE_ERROR_DETAIL: 'Service did not provide an error message',
  SERVER_DID_NOT_PROVIDE_AN_ERROR_MESSAGE:
    'Server did not provide an error message',
  HIDDEN_UNICODE_CHARACTERS_DETECTED:
    'Hidden characters detected. Please ensure these characters are intentional.',
  HIDE_FULL_VALUE: 'Hide full value',
  VIEW_FULL_VALUE: 'View full value',
  REMOVE_HIDDEN_CHARACTERS: 'Remove hidden characters',
  ERROR_ID_WITH_VALUE: 'Error ID: {id}',
  ERROR_COPY_TO_CLIPBOARD_TOOLTIP:
    'Copy to clipboard. Please provide this information when seeking support.',
  COPY_ERROR_DETAILS: 'Copy error details',
  IMPORT_ENTITY_NAME: 'Import {count} {entityName}...',
  CLEAR_ENTITY_NAME_FROM_IMPORT_MEMORY: 'Clear {entityName} from Import Memory',
  EXPORT_ALL_ENTITY_NAME: 'Export all Published {entityName}...',
  COPY_ALL_ENTITY_NAME_TO_ENVIRONMENT_AS_DRAFT:
    'Copy all {entityName} to {environmentName} as Draft',
  COPY_ALL_CONFIRMATION_TITLE: 'Copy all {entityName} to {environmentName}',
  COPY_ALL_CONFIRMATION_DESCRIPTION:
    'This will copy all published {entityName} to {environmentName} as Draft. You can optionally include draft {entityName} as well.',
  COPY_ALL_CONFIRMATION_INCLUDE_DRAFTS: 'Include draft {entityName}',
  COPY_ALL_CONFIRMATION_CONFIRM: 'Copy all',
  PROMOTE_SELECTED_ENTITIES: 'Copy selected {entityName} to {environmentName}',
  BULK_ACTIONS: 'Bulk actions',
  BULK_ITEMS_SELECTED: '{count, plural, one {# selected} other {# selected}}',
  STATUS_PROGRESS_SUCCESSFUL_COUNT:
    '{count, plural, one {# successful} other {# successful}}',
  STATUS_PROGRESS_SKIPPED_COUNT:
    '{count, plural, one {# skipped} other {# skipped}}',
  STATUS_PROGRESS_FAILED_COUNT:
    '{count, plural, one {# failed} other {# failed}}',
  STATUS_PROGRESS_UNPROCESSED_COUNT:
    '{count, plural, one {# unprocessed} other {# unprocessed}}',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_IMPORT: 'Import progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_EXPORT: 'Export progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_COPY: 'Copy progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_DUPLICATION: 'Duplication progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_PUBLISH: 'Publish progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_ARCHIVE: 'Archive progress...',
  BULK_ACTION_REPORTING_PROGRESS_LABEL_DELETE: 'Delete progress...',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_IMPORTING: 'Importing',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_EXPORTING: 'Exporting',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_COPYING: 'Copying',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_DUPLICATING: 'Duplicating',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_PUBLISHING: 'Publishing',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_ARCHIVING: 'Archiving',
  BULK_ACTION_REPORTING_PROGRESS_ACTION_DELETING: 'Deleting',
  BULK_ACTION_REPORTING_MODAL_TITLE_VERB_DUPLICATED: 'Duplicated',
  BULK_ACTION_REPORTING_MODAL_TITLE_VERB_ARCHIVED: 'Archived',
  BULK_ACTION_REPORTING_MODAL_TITLE_VERB_DELETED: 'Deleted',
  BULK_ACTION_REPORTING_MODAL_TITLE: '{operation} {entityType}',
  BULK_ACTION_REPORTING_MODAL_TITLE_COMPLETED_WITH_ERRORS:
    '{operation} {entityType} with errors',
  BULK_ACTION_REPORTING_MODAL_TITLE_COPYING_TO_ENV:
    'Copying to {targetEnvironment}',
  BULK_ACTION_REPORTING_MODAL_TITLE_DONE_COPYING_TO_ENV:
    'Done copying to {targetEnvironment}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_IMPORTING:
    'Done importing <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_EXPORTING:
    'Done exporting <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_COPYING:
    'Done copying <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_DUPLICATING:
    'Done duplicating <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_PUBLISHING: 'Done publishing entities',
  BULK_ACTION_REPORTING_PROGRESS_DONE_ARCHIVING:
    'Done archiving <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_DONE_DELETING:
    'Done deleting <strong>{count}</strong> {count, plural, one {{entityLabel}} other {{entityLabelPlural}}}',
  BULK_ACTION_REPORTING_PROGRESS_ENTITY_SINGULAR: 'entity',
  BULK_ACTION_REPORTING_PROGRESS_ENTITY_PLURAL: 'entities',
  BULK_ACTION_REPORTING_PROGRESS_COMPLETE: 'Complete!',
  BULK_ACTION_REPORTING_PROGRESS_COMPLETE_WITH_ERRORS: 'Complete, with errors',
  BULK_ACTION_REPORTING_PROGRESS_FAILED_AT_MESSAGE:
    'Stopped at {entityLabel} <strong>{succeededCount} of {totalCount}</strong>',
  BULK_ACTION_REPORTING_PROGRESS_ERROR: 'Error',
  BULK_ACTION_REPORTING_PROGRESS_ACTIVE_MESSAGE:
    '{action} {entityLabel} <strong>{processedCount} of {totalCount}</strong>',
  BULK_ACTION_REPORTING_PROGRESS_STOPPED_AT_MESSAGE:
    'Stopped at {entityLabel} <strong>{processedCount} of {totalCount}</strong>',
  BULK_ARCHIVE_SELECTED_ENTITIES: 'Archive selected {entityName}',
  BULK_ARCHIVE_CONFIRM_TITLE: 'Archive selected {entityName}?',
  BULK_ARCHIVE_CONFIRM_DESCRIPTION:
    'The selected draft {entityName} will be archived. This action can be undone by unarchiving individual entities.',
  BULK_ARCHIVE_CONFIRM_CTA: 'Archive {entityName}',
  BULK_DELETE_SELECTED_ENTITIES: 'Delete selected {entityName}',
  BULK_DELETE_CONFIRM_TITLE: 'Permanently delete selected {entityName}?',
  BULK_DELETE_CONFIRM_DESCRIPTION:
    'The selected archived {entityName} will be permanently deleted. This action cannot be undone.',
  BULK_DELETE_CONFIRM_CTA: 'Delete {entityName}',
  BULK_ENTITY_ACTIONS: 'Bulk {entityName} actions',
  BULK_PROMOTE_MESSAGE_SKIPPED_ENTITIES:
    'Some entities were skipped since they already existed. You should confirm if data needs to be synced between environments.',
  BULK_ACTION_REPORTING_PROGRESS_LOADING_MESSAGE:
    'Please wait for {operation} to complete. <strong>Do not</strong> close this browser window...',
  BULK_ACTION_BANNER_IMPORT_COMPLETED_TITLE:
    'Successfully imported all {entityType}!',
  BULK_ACTION_BANNER_IMPORT_COMPLETED_WITH_SKIPS_TITLE:
    'Completed importing {entityType}.',
  BULK_ACTION_BANNER_IMPORT_COMPLETED_WITH_SKIPS_MESSAGE:
    'Some entities were skipped because they already existed.',
  BULK_ACTION_BANNER_IMPORT_COMPLETED_WITH_ERRORS_TITLE:
    'Completed importing {entityType}.',
  BULK_ACTION_BANNER_IMPORT_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to import. Review the list above for details.',
  BULK_ACTION_BANNER_IMPORT_FAILED_TITLE: 'Error importing {entityType}.',
  BULK_ACTION_BANNER_EXPORT_COMPLETED_TITLE:
    'Successfully exported all {entityType}!',
  BULK_ACTION_BANNER_EXPORT_COMPLETED_WITH_SKIPS_TITLE:
    'Completed exporting {entityType}.',
  BULK_ACTION_BANNER_EXPORT_COMPLETED_WITH_SKIPS_MESSAGE:
    'Some entities were skipped during export. Review the list above for details.',
  BULK_ACTION_BANNER_EXPORT_COMPLETED_WITH_ERRORS_TITLE:
    'Completed exporting {entityType}.',
  BULK_ACTION_BANNER_EXPORT_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to export. Review the list above for details.',
  BULK_ACTION_BANNER_EXPORT_FAILED_TITLE: 'Error exporting {entityType}.',
  BULK_ACTION_BANNER_FAILED_MESSAGE:
    'The {operation} failed because some {entityType} could not be {operationPastTense}.',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_IMPORTED: 'imported',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_EXPORTED: 'exported',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_COPIED: 'copied',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_DUPLICATED: 'duplicated',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_PUBLISHED: 'published',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_ARCHIVED: 'archived',
  BULK_ACTION_BANNER_FAILED_OPERATION_PAST_TENSE_DELETED: 'deleted',
  BULK_ACTION_BANNER_PUBLISH_COMPLETED_TITLE:
    'Successfully published all {entityType}!',
  BULK_ACTION_BANNER_PUBLISH_COMPLETED_WITH_SKIPS_TITLE:
    'Completed publishing {entityType}.',
  BULK_ACTION_BANNER_PUBLISH_COMPLETED_WITH_ERRORS_TITLE:
    'Completed publishing {entityType}.',
  BULK_ACTION_BANNER_PUBLISH_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to publish. Review the list above for details.',
  BULK_ACTION_BANNER_PUBLISH_FAILED_TITLE: 'Error publishing {entityType}.',
  BULK_ACTION_REPORT_OPERATION_NOUN_PUBLISH: 'publish',
  BULK_ACTION_BANNER_ARCHIVE_COMPLETED_TITLE:
    'Successfully archived all {entityType}!',
  BULK_ACTION_BANNER_ARCHIVE_COMPLETED_WITH_SKIPS_TITLE:
    'Completed archiving {entityType}.',
  BULK_ACTION_BANNER_ARCHIVE_COMPLETED_WITH_ERRORS_TITLE:
    'Completed archiving {entityType}.',
  BULK_ACTION_BANNER_ARCHIVE_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to archive. Review the list above for details.',
  BULK_ACTION_BANNER_ARCHIVE_FAILED_TITLE: 'Error archiving {entityType}.',
  BULK_ACTION_REPORT_OPERATION_NOUN_ARCHIVE: 'archive',
  BULK_ACTION_BANNER_DELETE_COMPLETED_TITLE:
    'Successfully deleted all {entityType}!',
  BULK_ACTION_BANNER_DELETE_COMPLETED_WITH_SKIPS_TITLE:
    'Completed deleting {entityType}.',
  BULK_ACTION_BANNER_DELETE_COMPLETED_WITH_ERRORS_TITLE:
    'Completed deleting {entityType}.',
  BULK_ACTION_BANNER_DELETE_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to delete. Review the list above for details.',
  BULK_ACTION_BANNER_DELETE_FAILED_TITLE: 'Error deleting {entityType}.',
  BULK_ACTION_REPORT_OPERATION_NOUN_DELETE: 'delete',
  BULK_ACTION_BANNER_COPY_COMPLETED_TITLE:
    'Successfully copied all {entityType}!',
  BULK_ACTION_BANNER_COPY_FAILED_TITLE: 'Error copying {entityType}.',
  BULK_ACTION_BANNER_COPY_COMPLETED_WITH_SKIPS_TITLE:
    'Completed copying {entityType}.',
  BULK_ACTION_BANNER_COPY_COMPLETED_WITH_ERRORS_TITLE:
    'Completed copying {entityType}.',
  BULK_ACTION_BANNER_COPY_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to copy. View them from the list above in order to resolve any errors, then copy them individually.',
  BULK_ACTION_BANNER_CLONE_COMPLETED_TITLE:
    'Successfully duplicated entity and all of its children.',
  BULK_ACTION_BANNER_CLONE_FAILED_TITLE:
    'Error duplicating entity and its children.',
  BULK_ACTION_BANNER_CLONE_COMPLETED_WITH_ERRORS_TITLE:
    'Completed duplicating entity and its children.',
  BULK_ACTION_BANNER_CLONE_COMPLETED_WITH_ERRORS_MESSAGE:
    'Some entities failed to duplicate. Review the list above for details.',
  BULK_ACTION_REPORT_OPERATION_TYPE_IMPORT: 'import',
  BULK_ACTION_REPORT_OPERATION_TYPE_EXPORT: 'export',
  BULK_ACTION_REPORT_OPERATION_TYPE_COPY: 'copy',
  BULK_ACTION_REPORT_OPERATION_TYPE_DUPLICATE: 'duplicate',
  BULK_ACTION_REPORT_OPERATION_NOUN_DUPLICATION: 'duplication',
  BULK_ACTION_REPORT_OPERATION_TYPE_PUBLISH: 'publish',
  BULK_ACTION_REPORT_OPERATION_TYPE_ARCHIVE: 'archive',
  BULK_ACTION_REPORT_OPERATION_TYPE_DELETE: 'delete',
  BULK_ACTION_REPORT_SWITCH_ENVIRONMENT: 'Switch environment',
  BULK_ACTION_REPORT_STATUS_IMPORTED: 'Imported',
  BULK_ACTION_REPORT_STATUS_IMPORTING: 'Importing',
  BULK_ACTION_REPORT_STATUS_EXPORTED: 'Exported',
  BULK_ACTION_REPORT_STATUS_EXPORTING: 'Exporting',
  BULK_ACTION_REPORT_STATUS_CREATED: 'Created',
  BULK_ACTION_REPORT_STATUS_DUPLICATING: 'Duplicating',
  BULK_ACTION_REPORT_STATUS_COPIED: 'Copied',
  BULK_ACTION_REPORT_STATUS_COPYING: 'Copying',
  BULK_ACTION_REPORT_STATUS_PUBLISHED: 'Published',
  BULK_ACTION_REPORT_STATUS_PUBLISHING: 'Publishing',
  BULK_ACTION_REPORT_STATUS_ARCHIVED: 'Archived',
  BULK_ACTION_REPORT_STATUS_ARCHIVING: 'Archiving',
  BULK_ACTION_REPORT_STATUS_DELETED: 'Deleted',
  BULK_ACTION_REPORT_STATUS_DELETING: 'Deleting',
  BULK_ACTION_REPORT_STATUS_SKIPPED: 'Skipped',
  BULK_ACTION_REPORT_STATUS_FAILED: 'Failed',
  BULK_ACTION_REPORT_ERROR_FALLBACK: 'Failed to {operation} {entityType}',
  BULK_ACTION_REPORT_ERROR_WITH_DETAIL:
    'Failed to {operation} {entityType}: {detail}',
  BULK_ACTION_REPORT_SEE_SOURCE_ENTITY: 'See source {entityType}',
  BULK_ACTION_REPORT_ITEM_LABEL: '{entityType}: {entityName}',
  BULK_ACTION_REPORT_ALREADY_EXISTS:
    '{entityType} already exists: {entityName}',
  BULK_ACTION_REPORT_ALREADY_EXPORTED: '{entityType} already exported',
  BULK_ACTION_REPORT_ALREADY_PUBLISHED: '{entityType} already published',
  BULK_ACTION_REPORT_ALREADY_ARCHIVED: '{entityType} already archived',
  BULK_ACTION_REPORT_ALREADY_DELETED: '{entityType} already deleted',
  NO_ENTITIES_TO_IMPORT_TOOLTIP: 'Export {entityName} from a tenant first.',
  NO_ENTITIES_TO_IMPORT: 'No {entityName} to Import',
  NO_ENTITIES_TO_CLEAR_TOOLTIP: 'No {entityName} exist to clear',
  DISCARD_EXISTING_EXPORTED_DATA_TITLE:
    'Discard existing exported {entityName}?',
  DISCARD_EXISTING_EXPORTED_DATA_DESCRIPTION:
    'To export a new batch of {entityName}, you must clear the data that is currently stored. You can export it again in the future.',
  DISCARD_EXISTING_AND_EXPORT_NEW:
    'Discard existing and export new {entityName}',
  ERROR_EXPORTING_ENTITIES: 'Error exporting {domainEntityName}',
  ERROR_EXPORTING_ENTITIES_MESSAGE_FALLBACK:
    'An error occurred while exporting entities.',
  ERROR_EXPORTING_ENTITIES_MESSAGE:
    'Please try again or contact support if the issue persists.',
  EXPORT_CTA_TEXT: 'Click here to log out',
  BULK_ACTION_LOADING_MESSAGE: 'Do not close this browser window.',
  ERROR_COUNT: '{count, plural, one {Error} other {Errors}}',
  UNPROCESSED: 'Unprocessed',
  DOWNLOAD_IMPORT_RESULTS_AS_CSV: 'Download Import Results as CSV',
  DOWNLOAD_DOMAIN_ENTITY_ID_MAPPINGS_AS_JSON:
    'Download Domain Entity ID Mappings as JSON',
  MAINTENANCE_TITLE: "We're sprucing things up!",
  MAINTENANCE_DESCRIPTION:
    'The {tenantId} workspace is currently undergoing scheduled maintenance. Please check back soon.',
  MAINTENANCE_SWITCH_WORKSPACE: 'Switch to a different workspace',
  MAINTENANCE_IMAGE_ALT: 'Maintenance illustration',
  CLEAR_SELECTED_ASSET: 'Clear selected asset',
  ...EN_STRING_ACTIVITY_OVERRIDES,
  ...EN_CAMPAIGN_STRINGS,
  ...EN_QUESTION_CODE_STRINGS,
  ...EN_QUESTION_UNIT_STRINGS,
  ...EN_QUESTIONNAIRE_STRINGS,
  ...EN_MASONRY_QUESTIONNAIRE_STRINGS,
  ...EN_REWARDS_CONFIGURATION_STRINGS,
  ...EN_CONDITIONAL_ACTION_STRINGS,
  ...EXAMPLE_ENTITY_STRINGS,
  ...EN_LPF_STRINGS,
  ...COMMON_ENTITY_STRINGS,
  ...EN_TEST_USER_STRINGS,
  ...EN_CAREGIVER_STRINGS,
  ...EN_BENEFITS_STRINGS,
  ...EN_MEDIA_STRINGS,
  ...EN_CONTENT_METADATA_STRINGS,
  ...EN_MASONRY_CONTENT_STRINGS,
  ...EN_MEMBER_OUTREACH_RECOMMENDATIONS_STRINGS,
  ...EN_MEMBER_OUTREACH_QUESTIONNAIRES_STRINGS,
  ...EN_APP_REVIEW_STRINGS,
  /** Analytics */
  ANALYTICS: 'Analytics',
  KPI_DASHBOARD: 'KPI Dashboard',
  SELF_REPORTED_DASHBOARD: 'Self-Reported Actions & Outcomes',
  ANALYTICS_DASHBOARD: 'Analytics Dashboard',
  ANALYTICS_EMBED_LOAD_ERROR_HEADING: "Couldn't load dashboard",
  ANALYTICS_EMBED_NO_URL_RETURNED: 'Backend did not return an embed URL',
  ANALYTICS_EMBED_LOAD_GENERIC_ERROR: 'Failed to load dashboard',
  ANALYTICS_EMBED_RETRY_BUTTON: 'Try again',
  /** Feature Flags Page */
  FEATURE_FLAGS: 'Feature flags',
  FEATURE_FLAGS_DESCRIPTION:
    "These flags are stored in localStorage in this browser. Toggling them is equivalent to calling localStorage.setItem(key, 'true' | 'false'). Some flags may be automatically enabled for your account based on your email domain or tenant and can be overridden using the 'Override auto-enabled flags' option.",
  FEATURE_FLAGS_OVERRIDE_AUTO_ENABLED: 'Override auto-enabled flags',
  FEATURE_FLAGS_OVERRIDE_AUTO_ENABLED_TOOLTIP:
    'When enabled, flags that are automatically enabled for your account can be toggled manually.',
  FEATURE_FLAGS_AUTO_ENABLED_TOOLTIP:
    'This flag is automatically enabled for your account based on your email domain or tenant.',
  FEATURE_FLAGS_TURN_ALL_ON: 'Turn all on',
  FEATURE_FLAGS_TURN_ALL_OFF: 'Turn all off',
  BACK_TO_HOME: 'Back to home',
  SCROLL_TO_BOTTOM: 'Scroll to bottom',
  ENVIRONMENT: 'Environment',
  ERROR: 'Error',
  PERMISSIONS_ERROR_HEADING:
    'Sorry, you do not have permission to access this page. Please log out or try again.',
  /** Activity Translation Page */
  ACTIVITY_TRANSLATION_PAGE_TITLE: 'Activity Translation Import/Export',
  ACTIVITY_TRANSLATION_PAGE_DESCRIPTION:
    'Export and import translatable strings for Toolbox Activity entries.',
  ACTIVITY_TRANSLATION_DEFAULT_LOCALE: 'Default locale: {locale}',
  ACTIVITY_TRANSLATION_BACK: 'Back',
  ACTIVITY_TRANSLATION_EXPORT_TAB: 'Export Strings',
  ACTIVITY_TRANSLATION_IMPORT_TAB: 'Import Translations',
  ACTIVITY_TRANSLATION_EXPORT_HEADING: 'Export Strings for Translation',
  ACTIVITY_TRANSLATION_ENTRY_IDS_LABEL: 'Entry IDs (one per line)',
  ACTIVITY_TRANSLATION_ENTRY_IDS_PLACEHOLDER:
    'Enter Toolbox Activity entry IDs, one per line...',
  ACTIVITY_TRANSLATION_ENTRY_COUNT:
    '{count} entry {count, plural, one {ID} other {IDs}} entered',
  ACTIVITY_TRANSLATION_MAX_ENTRY_IDS:
    'Maximum {max} entry IDs allowed. Please reduce the number of entries.',
  ACTIVITY_TRANSLATION_EXPORT_BUTTON: 'Export Strings',
  ACTIVITY_TRANSLATION_EXPORTING_BATCH: 'Exporting batch {current}/{total}...',
  ACTIVITY_TRANSLATION_EXPORTING: 'Exporting...',
  ACTIVITY_TRANSLATION_PROCESSING_BATCHES: 'Processing Batches...',
  ACTIVITY_TRANSLATION_PROCESSING_BATCH_PROGRESS:
    'Processing batch {current} of {total} ({percent}%)',
  ACTIVITY_TRANSLATION_PROGRESS_LOG: 'Progress Log',
  ACTIVITY_TRANSLATION_EXPORT_RESULT:
    'Exported {totalStrings} strings from {totalEntries} entries.',
  ACTIVITY_TRANSLATION_DOWNLOAD_JSON: 'Download JSON File',
  ACTIVITY_TRANSLATION_EXPORT_LOG: 'Export Log',
  ACTIVITY_TRANSLATION_IMPORT_HEADING: 'Import Translations',
  ACTIVITY_TRANSLATION_TARGET_LOCALE: 'Target Locale',
  ACTIVITY_TRANSLATION_SELECT_LOCALE: 'Select a locale...',
  ACTIVITY_TRANSLATION_LOCALE_HINT:
    'Translations will be imported to the {locale} locale',
  ACTIVITY_TRANSLATION_FILE_LABEL: 'Translations File (JSON)',
  ACTIVITY_TRANSLATION_FILE_SELECTED: 'Selected: {fileName}',
  ACTIVITY_TRANSLATION_FILE_CHANGE: 'Click to change file',
  ACTIVITY_TRANSLATION_FILE_DROP: 'Drop a JSON file here or click to browse',
  ACTIVITY_TRANSLATION_FILE_HINT:
    'File should contain key-value pairs of original text to translated text',
  ACTIVITY_TRANSLATION_IMPORT_ENTRY_IDS_LABEL:
    'Entry IDs to update (one per line)',
  ACTIVITY_TRANSLATION_IMPORT_WILL_UPDATE:
    'Will update {count} specified entries',
  ACTIVITY_TRANSLATION_IMPORT_ENTER_IDS: 'Enter entry IDs to update',
  ACTIVITY_TRANSLATION_IMPORT_BUTTON: 'Import Translations',
  ACTIVITY_TRANSLATION_IMPORTING_BATCH: 'Importing batch {current}/{total}...',
  ACTIVITY_TRANSLATION_IMPORTING: 'Importing...',
  ACTIVITY_TRANSLATION_IMPORT_UPDATED:
    'Updated {updatedEntries} of {totalEntries} entries',
  ACTIVITY_TRANSLATION_IMPORT_PUBLISHED: 'Published {publishedEntries} entries',
  ACTIVITY_TRANSLATION_IMPORT_APPLIED:
    'Applied {totalStringsApplied} string translations',
  ACTIVITY_TRANSLATION_IMPORT_LOG: 'Import Log',
  ACTIVITY_TRANSLATION_EXPORT_FAILED: 'Export Failed',
  ACTIVITY_TRANSLATION_EXPORT_COMPLETED_WITH_ERRORS:
    'Export Completed with Errors',
  ACTIVITY_TRANSLATION_EXPORT_COMPLETE: 'Export Complete',
  ACTIVITY_TRANSLATION_IMPORT_FAILED: 'Import Failed',
  ACTIVITY_TRANSLATION_IMPORT_COMPLETED_WITH_ERRORS:
    'Import Completed with Errors',
  ACTIVITY_TRANSLATION_IMPORT_COMPLETE: 'Import Complete',
  ACTIVITY_TRANSLATION_ERROR_JSON_FILE: 'Please select a JSON file',
  ACTIVITY_TRANSLATION_ERROR_ENTRY_IDS: 'Please provide entry IDs',
  ACTIVITY_TRANSLATION_ERROR_LOCALE_AND_FILE:
    'Please select a locale and provide a translations file',
  ACTIVITY_TRANSLATION_ERROR_PARSE_FILE: 'Failed to parse translations file',
  ACTIVITY_TRANSLATION_ERROR_BATCH_FAILED: 'Batch {batch} failed',
  ACTIVITY_TRANSLATION_LOG_SUMMARY:
    '{title} - {successCount} success, {warningCount} warnings, {errorCount} errors, {skippedCount} skipped',
  ACTIVITY_TRANSLATION_LOG_FILTER_ALL: 'All ({count})',
  ACTIVITY_TRANSLATION_LOG_FILTER_SUCCESS: 'Success ({count})',
  ACTIVITY_TRANSLATION_LOG_FILTER_WARNINGS: 'Warnings ({count})',
  ACTIVITY_TRANSLATION_LOG_FILTER_ERRORS: 'Errors ({count})',
  ACTIVITY_TRANSLATION_LOG_COPY_IDS: 'Copy {count} IDs',
  ACTIVITY_TRANSLATION_LOG_COPIED_IDS: 'Copied {count} IDs!',
  ACTIVITY_TRANSLATION_LOG_COPY_FAILED: 'Failed to copy to clipboard',
  ACTIVITY_TRANSLATION_LOG_EXPORTED_STRINGS: 'exported {count} strings',
  ACTIVITY_TRANSLATION_LOG_EXACT_MATCH:
    '{count} exact {count, plural, one {match} other {matches}}',
  ACTIVITY_TRANSLATION_LOG_FUZZY_MATCH:
    '{count} fuzzy {count, plural, one {match} other {matches}}',
  ACTIVITY_TRANSLATION_LOG_NOT_MATCHED: '{count} not matched',
  ACTIVITY_TRANSLATION_LOG_APPLIED_TRANSLATIONS:
    'applied {applied} translations ({total} strings: {breakdown})',
  ACTIVITY_TRANSLATION_LOG_FUZZY_APPLIED: 'Fuzzy match applied ({percent}%):',
  ACTIVITY_TRANSLATION_LOG_ORIGINAL: 'Original: "{text}"',
  ACTIVITY_TRANSLATION_LOG_MATCHED_TO: 'Matched to: "{text}"',
  ACTIVITY_TRANSLATION_LOG_NO_MATCH_FOUND: 'No match found:',
  ACTIVITY_TRANSLATION_LOG_BEST_MATCH: 'Best match ({percent}%): "{text}"',
  ACTIVITY_TRANSLATION_LOG_NO_SIMILAR: 'No similar string found',
  BACK: 'Back',
  TOOLS: 'Tools',
};
